import React, { useContext } from 'react';
import { AddStorageDataContext } from 'context/AddStorageContext';
import styled from 'styled-components';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';

import AvatarGrid from '../Components/AvatarGrid';

const ShareIconStyle = styled.div`
	height: 200px;

	.ScrollbarsCustom-Track {
		right: -10px !important;
		top: 0px !important;
	}
	.ScrollbarsCustom-ThumbY {
		background-color: ${props => props.theme.storage} !important;
		width: 6px !important;
	}
	.ScrollbarsCustom-TrackY:before {
		border-left: none;
	}
	.ScrollbarsCustom-TrackY {
		background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
		box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
		width: 6px !important;
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		height: 200px;

		.ScrollbarsCustom-Track {
			right: -10px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.storage} !important;
			width: 8px !important;
		}

		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 8px !important;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		height: 500px;
		max-width: 720px !important;
		.ScrollbarsCustom-Track {
			right: -10px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.storage} !important;
			width: 10px !important;
		}

		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 10px !important;
		}
	}
`;

export const ShareIconScreen = () => {
	const { inputs, change } = useContext(AddStorageDataContext);
	const selected = inputs?.icon;
	return (
		<ShareIconStyle className='share-icon-wrapper'>
			<ScrollView>
				<AvatarGrid onSelect={change} selected={selected} />
			</ScrollView>
		</ShareIconStyle>
	);
};
